<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-users-cog"></i> Active Directory (AD)</h3>
      </div>
    </div>
    <Forms
      ref="frmAD"
      :title="'Configurações do Active Directory'"
      :showClearButton="false"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label><small v-show="form.servidor.required" class="text-danger">*</small> Servidor:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'meu.ldap.server.hostname ou IP'"
                          v-model="form.servidor.value"
                          :size="form.servidor.maxlength"
                          :required="form.servidor.required"
                          :state="form.servidor.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label><small v-show="form.porta.required" class="text-danger">*</small> Porta:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'3268'"
                          v-model="form.porta.value"
                          :size="form.porta.maxlength"
                          :required="form.porta.required"
                          :state="form.porta.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label><small v-show="form.dn.required" class="text-danger">*</small> DN <small>(Distinguished Name)</small>:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'dc=example,dc=com'"
                          v-model="form.dn.value"
                          :size="form.dn.maxlength"
                          :required="form.dn.required"
                          :state="form.dn.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label><small v-show="form.caminho.required" class="text-danger">*</small> Path DN:</label>
          <div class="input-group">
            <span class="input-group-addon" style="font-size: 11px;font-weight: 700;">LDAP://</span>
            <b-form-input type="text"
                          :placeholder="'dc=minhaempresa,dc=examplo,dc=com'"
                          v-model="form.caminho.value"
                          :size="form.caminho.maxlength"
                          :required="form.caminho.required"
                          :state="form.caminho.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <small>
            <ul>
              <li>CN = Common Name</li>
              <li>OU = Organizational Unit</li>
              <li>DC = Domain Component</li>
            </ul>
          </small>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
// import Tools from '@/components/tools/Tools.js'
import LdapRepository from '@/shared/http/repositories/configurations/ldap.js'

const ActiveDirectoryForms = {
  servidor: {
    value: '',
    required: true,
    state: null
  },
  porta: {
    value: '',
    required: true,
    state: null
  },
  dn: {
    value: '',
    required: true,
    state: null
  },
  caminho: {
    value: '',
    required: true,
    state: null
  }
}

const ActiveDirectoryModel = {
  id: null,
  servidor: '',
  porta: 0,
  caminho: '',
  dn: '',
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}

export default {
  name: 'AD',
  mixins: [ActionsForm],
  data () {
    return {
      data: ActiveDirectoryModel,
      form: ActiveDirectoryForms,
      id: null
    }
  },
  watch: {
    'form.servidor.value' (val) {
      if (val) {
        this.form.caminho.value = val
      }
    },
    'form.porta.value' (val) {
      if (val) {
        this.form.caminho.value = this.form.servidor.value + ':' + val
      }
    },
    'form.dn.value' (val) {
      if (val) {
        this.form.caminho.value = this.form.servidor.value + ':' + this.form.porta.value + '/' + val
      }
    }
  },
  methods: {
    onLoad () {
      loading.push()
      LdapRepository.GetAll()
        .then((response) => {
          loading.close()
          var ldap = response.data.content
          if (ldap) {
            this.onEdit(ldap[0])
          }
        })
        .catch(this.onException)
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        this.data.id = obj.id
        this.data.status = 1
        this.form.servidor.value = obj.servidor
        this.form.porta.value = obj.porta
        this.form.dn.value = obj.dn
        loading.pop()
      }
    },
    onCreate () {
      loading.push()
      this.data.porta = this.form.porta.value
      LdapRepository.Create(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.porta = this.form.porta.value
      LdapRepository.Update(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/activedirectory/ad.vue